import { DataConverter } from "../../../Global/Base/Converters/DataConverter";
import { IComparable } from "../../../Global/Base/IComparable";

export class OWDateTime implements IComparable {
    public ticksLo: number;
    public ticksHi: number;

    // UnixEpoch - reprezentuji hodnotu 621355968000000000 ( AIC19/V/nwg= ) coz je datum 1.1.1970 00:00:00 v typu OWDateTime
    public static ticksLo1970: number = 4155867136;
    public static ticksHi1970: number = 144670709;

    public static timeZoneOffset: number = new Date().getTimezoneOffset() * 60000;

    constructor(ticksLo: number, ticksHi: number) {
        this.ticksLo = ticksLo;
        this.ticksHi = ticksHi;
    }

    public static fromBase64(data: string): OWDateTime {
        const a = DataConverter.base64ToArray(data);
        const dw = new DataView(a.buffer);
        const ticksLo = dw.getUint32(0, true);
        const ticksHi = dw.getUint32(4, true);
        return new OWDateTime(ticksLo, ticksHi);
    }

    // vraci pro stejne datum stejnou hodnotu jako Date.valueOf nebo Date.getTime
    // pocet milisekund od UnixEpoch - 1.1.1970 00:00:00 + aktualni casova zona
    // http://www.w3schools.com/jsref/jsref_valueof_date.asp
    public valueOf(): number {
        const hi = this.ticksHi - OWDateTime.ticksHi1970;
        const lo = this.ticksLo - OWDateTime.ticksLo1970;
        return (hi * 0x100000000 + lo) / 10000 + OWDateTime.timeZoneOffset;
    }

    //#region toString
    public toString(): string {
        return this.getJsDate().toString();
    }
    //#endregion

    // vraci objekt Date s casem v aktualni casove zone
    public getJsDate(): Date {
        return new Date(this.valueOf());
    }

    public compare(value: any): boolean {
        if (value instanceof OWDateTime) {
            return this.ticksLo === value.ticksLo && this.ticksHi === value.ticksHi;
        }
        return false;
    }
}
